import { getRequest, postRequest, replaceInUrl } from './index';
import apiEndpoints from './apiEndpoints';

export const buyProductForStorageRequest = (accountUid, payload) =>
  postRequest(
    replaceInUrl(apiEndpoints.orders.buyForStorage, { accountUid }),
    payload,
  );

export const buyProductForDeliveryRequest = (accountUid, payload) =>
  postRequest(
    replaceInUrl(apiEndpoints.orders.buyForDelivery, { accountUid }),
    payload,
  );

export const sellProductFromStorageRequest = (accountUid, payload) =>
  postRequest(
    replaceInUrl(apiEndpoints.orders.sellFromStorage, { accountUid }),
    payload,
  );

export const fractionalConversionRequest = (accountUid, data) =>
  postRequest(
    replaceInUrl(apiEndpoints.orders.fractionalConversion, { accountUid }),
    data,
  );

export const entrustWithdrawalRequestDistribution = (accountUid, data) =>
  postRequest(
    replaceInUrl(apiEndpoints.orders.iraCashDistribution, { accountUid }),
    data,
  );

export const entrustWithdrawalRequestTransfer = (accountUid, data) =>
  postRequest(
    replaceInUrl(apiEndpoints.orders.iraCashTransfer, { accountUid }),
    data,
  );

export const submitIraFeeWithdrawal = (accountUid, data) =>
  postRequest(
    replaceInUrl(apiEndpoints.orders.iraFeeWithdrawal, { accountUid }),
    data,
  );

export const postAchDepositRequest = (accountUid, data) =>
  postRequest(
    replaceInUrl(apiEndpoints.orders.achDeposit, { accountUid }),
    data,
  );

export const updateWireWithdrawalRequest = (accountUid, data) =>
  postRequest(
    replaceInUrl(apiEndpoints.orders.wireWithdrawal, { accountUid }),
    data,
  );

export const updateCheckWithdrawalRequest = (accountUid, data) =>
  postRequest(
    replaceInUrl(apiEndpoints.orders.checkWithdrawal, { accountUid }),
    data,
  );

export const verifyBuyForDeliveryRequest = (accountUid, data) =>
  postRequest(
    replaceInUrl(apiEndpoints.orders.verifyBuyForDelivery, { accountUid }),
    data,
  );

export const getQuotesForBuyStorage = (
  data,
  isSegregated,
  paymentTypeUid,
  addPaymentMethodData,
  orderEntryType,
) =>
  getRequest(replaceInUrl(apiEndpoints.orders.getQuotesForBuyStorage, data), {
    isSegregated,
    paymentTypeUid,
    addPaymentMethodData,
    orderEntryType,
  });

export const executeQuotesForBuyStorage = (data) =>
  postRequest(
    replaceInUrl(apiEndpoints.orders.executeQuotesForBuyStorage, data),
  );

export const getQuotesForDelivery = (
  data,
  paymentTypeUid,
  addPaymentMethodData,
  orderEntryType,
) =>
  getRequest(replaceInUrl(apiEndpoints.orders.getQuotesForDelivery, data), {
    paymentTypeUid,
    addPaymentMethodData,
    orderEntryType,
  });

export const getQuotesForSell = (data, isSegregated) =>
  getRequest(replaceInUrl(apiEndpoints.orders.getQuotesForSell, data), {
    isSegregated,
  });

export const getQuotesForSellFromHome = (data) => {
  // Only forward dropOff fields that have a value. The API rejects an empty
  // param (e.g. dropOffAddress2=) with a 400, but accepts it being absent.
  const dropOffParams = {
    dropOffCountry: data.dropOffCountry,
    dropOffState: data.dropOffState,
    dropOffCity: data.dropOffCity,
    dropOffZip: data.dropOffZip,
    dropOffAddress1: data.dropOffAddress1,
    dropOffAddress2: data.dropOffAddress2,
  };
  const params = Object.fromEntries(
    Object.entries(dropOffParams).filter(
      ([, value]) => value != null && value !== '',
    ),
  );
  return getRequest(
    replaceInUrl(apiEndpoints.orders.getQuotesForSellFromHome, data),
    params,
  );
};

export const executeQuotesForSell = (data) =>
  postRequest(replaceInUrl(apiEndpoints.orders.executeQuotesForSell, data));

export const executeQuotesForSellFromHome = (data) =>
  postRequest(
    replaceInUrl(apiEndpoints.orders.executeQuotesForSellFromHome, data),
  );

export const getLocationPrice = (accountUid, data) =>
  getRequest(
    replaceInUrl(apiEndpoints.orders.getLocationPrice, { accountUid }),
    data,
  );

export const getSellFromHomeHistory = ({ accountUid, transactionUid }) =>
  getRequest(
    replaceInUrl(apiEndpoints.orders.getSellFromHomeHistory, {
      accountUid,
      transactionUid,
    }),
  );

// accountUid is the path param; symbolCode + quantity are the query params.
// Response: { IRSReportingRequired: boolean }.
export const getSfhIrsReportingRequired = ({
  accountUid,
  symbolCode,
  quantity,
}) =>
  getRequest(
    replaceInUrl(apiEndpoints.orders.sfhIrsReportingRequired, { accountUid }),
    { symbolCode, quantity },
  );

// accountUid + transactionUid go in the path; CancellationReason is the JSON
// body (CancelSellFromHomeOrderRecord).
export const cancelSellFromHomeOrder = ({
  accountUid,
  transactionUid,
  CancellationReason,
}) =>
  postRequest(
    replaceInUrl(apiEndpoints.orders.cancelSellFromHome, {
      accountUid,
      transactionUid,
    }),
    { CancellationReason },
  );
